import React from "react";
import { AdminField } from "./adminSections";

interface FieldEditorProps {
  field: AdminField;
  value: string;
  onChange: (key: string, value: string) => void;
}

export const FieldEditor: React.FC<FieldEditorProps> = ({ field, value, onChange }) => {
  const isMultiline = field.type === "textarea" || field.type === "list" || field.type === "json";
  const isBoolean = field.type === "boolean";
  const isColor = field.type === "color";

  return (
    <div data-testid={`admin-field-${field.key}`} className="grid gap-1.5">
      <div className="flex items-center justify-between gap-2">
        <label htmlFor={field.key} className="text-xs font-semibold text-neutral-600">
          {field.label}
        </label>
        {field.type === "json" && (
          <span className="text-[10px] uppercase tracking-wide text-neutral-400">JSON</span>
        )}
      </div>
      {isBoolean ? (
        <label className="inline-flex w-fit cursor-pointer items-center gap-2 rounded-lg border border-neutral-300 px-3 py-2">
          <input
            id={field.key}
            data-testid={`admin-field-input-${field.key}`}
            type="checkbox"
            checked={value === "true"}
            onChange={(e) => onChange(field.key, e.target.checked ? "true" : "false")}
            className="h-4 w-4 rounded border-neutral-300 text-motor-red focus:ring-motor-red/40"
          />
          <span className="text-sm text-neutral-700">
            {value === "true" ? "Activado" : "Desactivado"}
          </span>
        </label>
      ) : isColor ? (
        <div className="flex items-center gap-2">
          <input
            data-testid={`admin-field-color-${field.key}`}
            type="color"
            value={/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(value) ? value : "#111111"}
            onChange={(e) => onChange(field.key, e.target.value)}
            className="h-9 w-12 shrink-0 cursor-pointer rounded-lg border border-neutral-300 bg-white"
          />
          <input
            id={field.key}
            data-testid={`admin-field-input-${field.key}`}
            type="text"
            value={value}
            onChange={(e) => onChange(field.key, e.target.value)}
            placeholder="#111111"
            className="w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-motor-red/40"
          />
        </div>
      ) : isMultiline ? (
        <textarea
          id={field.key}
          data-testid={`admin-field-input-${field.key}`}
          value={value}
          onChange={(e) => onChange(field.key, e.target.value)}
          rows={field.rows ?? (field.type === "json" ? 8 : field.type === "list" ? 4 : 3)}
          className={`w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-motor-red/40 ${
            field.type === "json" ? "font-mono text-xs" : ""
          }`}
        />
      ) : (
        <input
          id={field.key}
          data-testid={`admin-field-input-${field.key}`}
          type="text"
          value={value}
          onChange={(e) => onChange(field.key, e.target.value)}
          className="w-full rounded-lg border border-neutral-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-motor-red/40"
        />
      )}
    </div>
  );
};
